const Skeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="bg-surface-100-bg mx-5 my-2.5" ref={viewRef}>
      <div className="flex justify-between relative align-middle">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-16 rounded-sm skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden pt-2.5 -mr-5" style={{ flexFlow: 'wrap' }}>
        <div className="flex w-[477px]">
          {new Array(3).fill(0).map((_item, index) => {
            return (
              <div key={`skeleton-theme-list-item-${index}`} className="ml-4 first:ml-0 last:mr-5">
                <div className="w-[152px] h-[152px] bg-surface-200-bg skeleon  rounded-[12px]" />
                <div className="w-[64px] h-[13px] mt-1.5 bg-surface-200-bg skeleon" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
